export const HelpLinks = {
  businessClientText: 'Click here for help with business clients.',
  businessClientLink:
    'https://securityrisk.atlassian.net/wiki/spaces/SHD/pages/651460676/Business+Clients',
  customerText: 'Click here for help with customers.',
  customerLink:
    'https://securityrisk.atlassian.net/wiki/spaces/SHD/pages/665845907/Customers',
  siteText: 'Click here for help with sites.',
  siteLink:
    'https://securityrisk.atlassian.net/wiki/spaces/SHD/pages/665845897/Sites',
  visitorText: 'Click here for help with visitors.',
  visitorLink:
    'https://securityrisk.atlassian.net/wiki/spaces/SHD/pages/665878673/Visitors',
  personnelText: 'Click here for help with personnel.',
  personnelLink:
    'https://securityrisk.atlassian.net/wiki/spaces/SHD/pages/659587354/Personnel',
  assetText: 'Click here for help with assets.',
  assetLink:
    'https://securityrisk.atlassian.net/wiki/spaces/SHD/pages/659784376/Assets',
  assignAssetText: 'Click here for help with assigning assets.',
  assignAssetLink:
    'https://securityrisk.atlassian.net/wiki/spaces/SHD/pages/659784408/Assigning+Assets',
  patrolText: 'Click here for help with patrols.',
  patrolLink:
    'https://securityrisk.atlassian.net/wiki/spaces/SHD/pages/665878663/Patrols',
  assignPatrolText: 'Click here for help with assigning patrols.',
  assignPatrolLink:
    'https://securityrisk.atlassian.net/wiki/spaces/SHD/pages/665845943/Ad-Hoc+Patrols',
  zoneText: 'Click here for help with zones.',
  zoneLink:
    'https://securityrisk.atlassian.net/wiki/spaces/SHD/pages/665845914/Zones',
  eventText: 'Click here for help with incident reporting.',
  eventLink:
    'https://securityrisk.atlassian.net/wiki/spaces/SHD/pages/665845926/Incident+Reporting',
  emergencyText: 'Click here for help with emergency responses.',
  emergencyLink:
    'https://securityrisk.atlassian.net/wiki/spaces/SHD/pages/665616564/Emergencies',
  serviceText: 'Click here for help with services.',
  serviceLink:
    'https://securityrisk.atlassian.net/wiki/spaces/SHD/pages/665846338/Services',
  subscriptionText: 'Click here for help with your subscription.',
  subscriptionLink:
    'https://securityrisk.atlassian.net/wiki/spaces/SHD/pages/659784428/Managing+My+Subscription',
  companyLink:
    'https://securityrisk.atlassian.net/wiki/spaces/SHD/pages/667517008/Company+Profile',
  companyText: 'Click here for help with your company profile.',
  profileLink:
    'https://securityrisk.atlassian.net/wiki/spaces/SHD/pages/667582555/My+Profile',
  profileText: 'Click here for help with your personal profile.',
};
